// import consts from "@/consts"
import {getApiProps, updateObjectByDiff} from "@/lib/lib";
// import {arraySplitIntoChunks} from "@/lib/lib";

export default {
    state: {
        greenseeStops_index: [],
        greenseeStops: [],
        greenseeStops_last_hour: [],
    },
    actions: {
        fetchGreenseeStops4Date({dispatch ,commit, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today') args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.date) {
                    return reject(false)
                }
                if (args.unitId > 0 && !args.force) {
                    let index = getters.getGreenseStopsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                    if (index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchGreenseeStops4Date', args, time: Date.now() / 1000})
                let params = getApiProps('greenseeStops', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;
                this.$api.greenseeStops.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('clearGreenseeStops', response.data)
                            commit('setGreenseeStopsIndex', {...args, count: response.data.length})
                            if (args.unitId && isToday) {
                                dispatch('fetchGreenseeStopsLastTime', args)
                            }
                            if (!args.unitId && response.data.length) {
                                // debugger
                            }
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchGreenseeStops4Date', args, inprogress: false})
                    });
            })
        },
        fetchGreenseeStops4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.from || !args.to) {
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let greenseeStop = getters.getGreenseStops.find(t => (t.id && t.unit_id == args.unitId && t.time_start?.utc == args.from && t.time_end?.utc == args.to))
                    if (greenseeStop) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchGreenseeStops4Period', args, time: Date.now() / 1000})
                let params = getApiProps('greenseeStops', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;
                this.$api.greenseeStops.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeGreenseeStops', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchGreenseeStops4Period', args, inprogress: false})
                    });
            })
        },
        
        reloadGreenseeStops({commit, dispatch}, args) {
            commit('clearGreenseeStops')
            return dispatch('fetchGreenseeStops4Date', {date: 'today', ...args})
        },

        //sayHello() {}
    },
    mutations: {
        setGreenseeStopsIndex(state, params) {
            let i = state.greenseeStops_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.greenseeStops_index.push(Object.freeze({...params}))
            } else {
                state.greenseeStops_index[i] = Object.freeze({...state.greenseeStops_index[i], ...params})
            }
        },
        storeGreenseeStops(state, nStops) {
            nStops = nStops
                .filter(t => !state.greenseeStops.find(st => {
                    return st.unit_id == t.unit_id
                        && st.time_start?.utc == t.time_start?.utc
                        && st.time_end?.utc == t.time_end?.utc
                }))
            //.map(t => Object.freeze(t))

            // if(nStops.length) state.greenseeStops.push(...nStops)
            if (!nStops.length) return false
            if (!state.greenseeStops.length) {
                state.greenseeStops = nStops
                return true
            }
            nStops.forEach(function (nStop) {
                let i = state.greenseeStops.findIndex(st => {
                    return st.unit_id == nStop.unit_id
                        && st.time_start?.utc == nStop.time_start?.utc
                    // && st.time_end?.utc == nStop.time_end?.utc
                })
                if (i < 0) {
                    state.greenseeStops.push(nStop) //(Object.freeze(nStop))
                } else
                {
                    updateObjectByDiff(state.greenseeStops[i], nStop)
                    // nStop = {...state.greenseeStops[i], ...nStop}
                    // state.greenseeStops[i] = nStop //Object.freeze(nStop)
                }
            })
        },
        clearGreenseeStopsLastHour(state, args) {
            state.greenseeStops_last_hour = state.greenseeStops_last_hour.filter(st => {
                return st.unit_id != args.unitId || st.time_start?.utc >= args.time_start
            })

            let nStops = args.data
            nStops = nStops
                .filter(st => {
                    return st.time_end?.utc > args.time_start
                })
                .filter(t => !state.greenseeStops_last_hour.find(st => {
                    return st.unit_id == t.unit_id
                        && st.time_start?.utc == t.time_start?.utc
                        && st.time_end?.utc == t.time_end?.utc
                }))
            //.map(t => Object.freeze(t))

            // if(nStops.length) state.greenseeStops_last_hour.push(...nStops)
            if (!nStops.length) return false
            if (!state.greenseeStops_last_hour.length) {
                state.greenseeStops_last_hour = nStops
                return true
            }
            nStops.forEach(function (nStop) {
                let i = state.greenseeStops_last_hour.findIndex(st => {
                    return st.unit_id == nStop.unit_id
                        && st.time_start?.utc == nStop.time_start?.utc
                    // && st.time_end?.utc == nStop.time_end?.utc
                })
                if (i < 0) {
                    state.greenseeStops_last_hour.push(nStop) //(Object.freeze(nStop))
                } else
                {
                    updateObjectByDiff(state.greenseeStops_last_hour[i], nStop)
                    // nStop = {...state.greenseeStops_last_hour[i], ...nStop}
                    // state.greenseeStops_last_hour[i] = nStop //Object.freeze(nStop)
                }
            })
        },
        clearGreenseeStops(state) {
            state.greenseeStops_last_hour = [];
            state.greenseeStops = [];
            state.greenseeStops_index = [];
        },
    },
    getters: {
        getGreenseStopsIndex(state) {
            return state.greenseeStops_index
        },
        getGreenseStops(state) {
            return [...state.greenseeStops, ...state.greenseeStops_last_hour]
        },
        getGreenseStopsMaxTimeEndByUnitsIds(state) {
            return state.greenseeStops.reduce((MaxTimeEndByUnitsIds, greenseeStop) => {
                if(+(greenseeStop?.time_end?.utc || 0) > +(MaxTimeEndByUnitsIds[greenseeStop.unit_id] || 0)) {
                    MaxTimeEndByUnitsIds[greenseeStop.unit_id] = greenseeStop?.time_end?.utc
                }
                return MaxTimeEndByUnitsIds
            }, {})
        },
    }
}
